export default {
  unsuccessfull: {
    _tag: 'CSidebarNavItem',
    name: 'notifications',
    phrase: 'nav-unsuccessful-requests',
    to: '/unsuccessfull-requests',
    order: 4,
    icon: 'fa-regular fa-ban',
    roles: ['Admin','Sub Admin'],
  },
}
